;(function (angular, moment, _) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('sidebarButtons', sidebarButtonsDirective)

  SidebarButtonsController.$inject = ['PreferencesService']

  function SidebarButtonsController (PreferencesService) {
    var self = this

    self.$onInit = () => {
      this.isOpen = this.sidebar.filterVisible || this.sidebar.colVisible || this.sidebar.dataVisible || this.sidebar.criteriaVisible

      this.isCompanyPrefsValid = function () {
        return PreferencesService.isCompanyPrefsValid()
      }
    }
  }

  sidebarButtonsDirective.$inject = []

  function sidebarButtonsDirective () {
    return {
      restrict: 'E',
      scope: true,
      templateUrl: '/app/common/directives/sidebar-buttons/filters-columns-buttons.html',
      controller: SidebarButtonsController,
      controllerAs: 'ctrl',
      bindToController: {
        sidebar: '=',
        selection: '='
      }
    }
  }
})(window.angular, window.moment, window._)
